/* eslint-disable */
import cx from 'classnames';
import changeCase from 'change-object-case';
import { connect } from 'react-redux'
import React, { Component } from 'react';
import { Button, Form, InputGroup, FormGroup, FormControl, Radio, ControlLabel, HelpBlock, Checkbox, Alert } from 'react-bootstrap';
import { ss, url, authJsonHeader, parseTimeString, mapDispatch, money } from '../../utils/util';
import { Elements, StripeProvider, CardElement, injectStripe } from 'react-stripe-elements';

import OzFormComponent from './OzFormComponent';
import Loading from './Loading';
import './BookTimeSlot.css';

import {
  getTimeSlot,
  getBookingPrice,
  bookChargeIntegration,
} from '../../actions';


class BookTimeSlot extends OzFormComponent {

  state = {
    workflow: 'configure',
    name: '',
    email: '',
  };

  static fields = [];

  componentDidMount() {
    this.setState({ loading: true });
    this.props.getTimeSlot(this.props.timeSlotId, { local: true, silent: true })
      .then(resp => {
        let timeSlot = resp.obj;
        let privacy = null;
        if (timeSlot.privacy == 'always') {
          privacy = 'yes';
        } else if (timeSlot.privacy == 'no') {
          privacy = 'no';
        }
        this.setState({
          loading: false,
          privacy,
          timeSlot,
        });
      });
  }

  setNumSlots(num) {
    this.setState({ num, loadingPrice: true });
    this.props.getBookingPrice(this.props.timeSlotId, { local: true, silent: true }, { num })
      .then(resp => {
        this.setState({
          loadingPrice: false,
          price: resp.obj,
        })
      });
  }

  continueToPayment() {
    this.setState({ workflow: 'payment' });
  }

  renderConfigure() {
    let timeSlot = this.state.timeSlot;
    if (!timeSlot) return;

    let privacyNode;
    switch (timeSlot.privacy) {
      case 'always': break;
      case 'no':
        privacyNode = <div>This is not a private booking.</div>;
        break;
      case 'optional':
        privacyNode = this.renderFormGroup('Private booking?', 'pills', 'privacy', [[true, 'Yes'],[false, 'No']]);
        break;
    }
    privacyNode = (
      <div className={cx('privacy', timeSlot.privacy)}>
        {privacyNode}
      </div>
    );

    let numSlotsNodes = [];
    for (let i = timeSlot.minBookSlots; i < timeSlot.slotsLeft; i++) {
      let num = i;
      let node = (
        <div key={num} className={cx('num-slots-option', { active: this.state.num == num })} onClick={() => this.setNumSlots(num)}>
          {num}
        </div>
      );
      numSlotsNodes.push(node);
    }
    let numSlotsNode = (
      <div className="num-slots">
        <div className="question">How many players?</div>
        <div className="num-slot-options">{numSlotsNodes}</div>
      </div>
    );

    let priceNode;
    let price = this.state.price;
    if (this.state.loadingPrice) {
      priceNode = <Loading />;
    } else if (price) {
      priceNode = <div>{money(price.price)}</div>;
    }
    if (priceNode) {
      priceNode = <div className="price">{priceNode}</div>;
    }

    let continueNode;
    if (!this.state.loadingPrice && price) {
      continueNode = (
        <Button onClick={() => this.continueToPayment()}>
          Continue - {money(price.price)}
        </Button>
      );
    }

    return (
      <div className="configure">
        {privacyNode}
        {numSlotsNode}
        {priceNode}
        {continueNode}
      </div>
    );
  }

  onCardChange(e) {
    this.setState({ paymentEnabled: e.complete });
  }

  canPay() {
    return (
      this.state.paymentEnabled &&
      this.state.name &&
      this.state.email
    );
  }

  payAndBook() {
    if (!this.canPay()) {
      alert("error, can't submit payment for booking right now");
      return;
    }

    this.setState({ loadingPayment: true });
    this.props.stripe.createToken({ name: this.state.name, email: this.state.email })
      .then(s => {
        if (s.error) return;
        let params = {
          timeSlotId: this.props.timeSlotId,
          num: this.state.num,
          privacy: this.state.privacy,
          stripeToken: s.token,
          name: this.state.name,
          email: this.state.email,
          price: this.state.price.price,
        };
        console.log('pay with params:', params);
        this.props.bookChargeIntegration(params)
          .then(resp => {
            this.setState({ loadingPayment: false });
            console.log('book charge resp', resp);
          });
      });
  }

  renderPayment() {
    let timeSlot = this.state.timeSlot;
    if (!timeSlot) return;

    let msg;
    if (this.state.loadingPayment) {
      msg = <Loading size="small" />;
    } else {
      msg = <span>Pay and Book Now - {money(this.state.price.price)}</span>
    }
    let buttonNode = (
      <div className={cx('submit-payment', { enabled: this.canPay() })}>
        <Button
          onClick={() => this.payAndBook()}
          disabled={!this.canPay()}
          bsStyle="primary"
        >
          {msg}
        </Button>
      </div>
    );

    return (
      <div className="payment">
        <Button onClick={() => this.setState({ workflow: 'configure' })}>Back</Button>
        <div className="key-vals">
          <div>
            <div>Room</div>
            <div>{timeSlot.roomName}, {timeSlot.location.company}</div>
          </div>
          <div>
            <div>Address</div>
            <div>{timeSlot.location.address}</div>
          </div>
          <div>
            <div>Tickets</div>
            <div>{this.state.num}</div>
          </div>
          <div>
            <div>Private?</div>
            <div>{this.state.privacy}</div>
          </div>
        </div>

        <div className="customer-info">
          {this.renderFormGroup(null, 'text', 'name', { placeholder: 'Your name' })}
          {this.renderFormGroup(null, 'email', 'email', { placeholder: 'Your email address' })}
        </div>

        <div className="credit-card">
          <CardElement
               className="card"
               onChange={(e) => this.onCardChange(e)}
             />

          {buttonNode}
        </div>
      </div>
    );
  }

  renderFlow() {
    switch (this.state.workflow) {
      case 'configure': return this.renderConfigure();
      case 'payment': return this.renderPayment();
    }
  }

  renderBody() {
    return (
      <div className="BookTimeSlot">
        {this.state.loading && <Loading />}
        {!this.state.loading && this.renderFlow()}
      </div>
    );
  }
}


function mapStateToProps(state) {
  return {
  };
}

function mapDispatchToProps(dispatch) {
  return mapDispatch(dispatch, {
    getTimeSlot,
    getBookingPrice,
    bookChargeIntegration,
  });
}

export default injectStripe(connect(
  mapStateToProps,
  mapDispatchToProps,
)(BookTimeSlot));



/** WEBPACK FOOTER **
 ** ./src/components/partials/BookTimeSlot.js
 **/